import PropTypes from 'prop-types';

import clsx from 'clsx';
import styles from './LoaderSkeleton.module.scss';

const LoaderSkeleton = ({ width, height, customStyle }) => {
  const skeletonStyle = {
    width: width,
    height: height,
  };

  return (
    <div className={clsx(styles.loader, customStyle)} style={skeletonStyle} />
  );
};

LoaderSkeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customStyle: PropTypes.string,
};

export default LoaderSkeleton;
